export default __webpack_public_path__ + "static/media/triangle-pattern_cri-095.bab6cdf5.jpg";